<template>
    <div class="access-control-list">
        <div class="innerBox">
            <div v-if="this.$route.query.buyerName" class="mb20">主体名称：{{this.$route.query.buyerName}}<back></back></div>
            <div>
              <el-input placeholder="点位名称、设备序列号" class="w300 seekIpt" v-model="searchInput" @keyup.enter.native="search">
                    <i slot="suffix" class="el-input__icon el-icon-search" @click="search"></i>
              </el-input>
              <el-select class="ml20 w120" v-model="availableValue" @change="stateChange" clearable size="small" placeholder="状态">
                  <el-option v-for="item in availableTypes" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </div>
            <div>
              <el-button class="mt20" @click="add('accessAdd')" icon="el-icon-circle-plus-outline" type="primary">新增</el-button>
            </div>
            <div>
                <el-table :data="tableData" border style="width:calc(100% - 10px); margin-top: 10px" :cell-style="{'text-align': 'center'}" :header-cell-style="{'text-align': 'center'}" v-loading="tableLoading">
                    <el-table-column label="序号" width="80" type="index" >
                    </el-table-column>
                    <el-table-column prop="pointName" label="点位名称" min-width="150" show-overflow-tooltip>
                        <template slot-scope="scope">
                            {{scope.row.pointName ? scope.row.pointName: '-'}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="deviceType" label="设备类型" min-width="200" show-overflow-tooltip>
                        <template slot-scope="scope">
                            {{scope.row.deviceTypeStr}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="deviceSerial" label="设备序列号" min-width="200" show-overflow-tooltip>
                        <template slot-scope="scope">
                            {{scope.row.deviceSerial ? scope.row.deviceSerial: '-'}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="subEntityName" label="所属食堂" min-width="200" show-overflow-tooltip>
                        <template slot-scope="scope">
                            {{scope.row.subEntityName ? scope.row.subEntityName: '-'}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="updateTime" label="更新时间" min-width="200" show-overflow-tooltip>
                        <template slot-scope="scope">
                            {{scope.row.updateTime ? scope.row.updateTime: '-'}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="status" label="状态" min-width="120" show-overflow-tooltip>
                        <template slot-scope="scope">
                            {{scope.row.status==1?'启用':'禁用'}}
                        </template>
                    </el-table-column>
                    <el-table-column fixed="right" label="操作" min-width="330">
                        <template slot-scope="scope">
                            <el-button @click="edit(scope.row)" type="primary" plain size="small">编辑</el-button>
                            <el-button @click="useChange(scope.row)" type="danger" plain size="small">{{scope.row.status == true?'禁用':'启用'}}</el-button>
                            <el-button @click="del(scope.row)" type="warning" plain size="small">删除</el-button>
                        </template>
                    </el-table-column>    
                </el-table>
            </div>
            <ybPagination :page="page" @size-change="pageSizeChange" @current-change="pageCurrentChange" style="margin-top:10px;margin-right:10px"></ybPagination>
        </div>
        <el-dialog v-if="addDialogVisible" :visible.sync="addDialogVisible" :close-on-click-modal="false" :title="addTitle" style="padding-top: 0px;">
                <el-form :model="accessAdd" :rules="dataRules" ref="accessAdd" class="ml20 mr20" label-position="right" label-width="150px">
                    <div class="item">
                        <el-form-item label="点位名称：" prop="pointName">
                            <el-input class="w300" placeholder="请输入点位名称" maxlength="20" clearable v-model="accessAdd.pointName"></el-input>
                        </el-form-item>
                        <el-form-item label="所属食堂：" prop="subEntityId">
                            <el-select class="w300" v-model="accessAdd.subEntityId" clearable size="small" placeholder="请选择所属食堂">
                                <el-option v-for="item in subEntity" :key="item.id" :label="item.label" :value="item.value"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="设备类型：" prop="deviceType">
                            <el-select :disabled="addTitle == '编辑门禁设备'" class="w300" v-model="accessAdd.deviceType" clearable size="small" placeholder="请选择设备类型">
                                <el-option v-for="item in deviceTypes" :key="item.value" :label="item.label" :value="item.value"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="设备序列号：" prop="deviceSerial">
                            <el-input :disabled="addTitle == '编辑门禁设备'" class="w300" placeholder="请输入设备序列号" maxlength="20" clearable v-model="accessAdd.deviceSerial"></el-input>
                        </el-form-item>
                        <el-form-item v-if="addTitle == '新增门禁设备'" label="验证码：" prop="validateCode">
                            <el-input :disabled="addTitle == '编辑门禁设备'" class="w300" placeholder="请输入设备验证码" maxlength="20" clearable v-model="accessAdd.validateCode"></el-input>
                        </el-form-item>
                    </div>
                </el-form>
                <div class="footer">
                    <el-button @click="cancle" round>取消</el-button>
                    <el-button :loading='butLoading' type="primary" @click="submit('accessAdd')" round>保存</el-button>
                </div>
            </el-dialog>
    </div>
</template>

<script>
import Back from '@/components/back'		//返回上一个页面按钮
import ybPagination from '@/components/ybPagination'
import * as mapping from '@/utils/enumList'
import * as accessApi from '@/api/access'
export default {
    components: {
        Back,
        ybPagination
    },
    data(){
        return{
            searchInput:'',
            availableValue:'',
            addTitle:'',
            accessId:'',
            tableData:[],
            butLoading:false,
            accessAdd:{
                pointName:'',
                subEntityId:[],
                deviceType:'',
                deviceSerial:'',
                validateCode:'',
            },
            tableLoading:false,
            addDialogVisible:false,
            dataRules:{
                pointName: [
                    { required: true, message: '请输入点位名称, 20字以内', trigger: 'blur' }
                ],
                deviceType: [
                    { required: true, message: '请选择设备类型', trigger: 'change' }
                ],
                deviceSerial: [
                    { required: true, message: '请输入设备序列号, 20字以内', trigger: 'blur' }
                ],
                validateCode: [
                    { required: true, message: '请输入设备验证码, 20字以内', trigger: 'blur' }
                ],
                // subEntityId: [
                //     { required: true, message: '请选择所属食堂', trigger: 'change' }
                // ],
            },
            subEntity:[],
            availableTypes:[
                {value:'YES',label:'启用'},
                {value:'NO',label:'禁用'},
            ],
            deviceTypes:[
                {value:'HK',label:'海康'},
            ],
            page: {
                pageSize: 10,
                pageNum: 1,
                total: 0
            },
        }
    },
    created(){
        this.getList()
        this.getEntityListFun()
    },
    methods:{
        // 获取子食堂列表
        getEntityListFun(){
            let params = {
                entityId:this.$route.query.entityId
            }
            accessApi.getEntityList(params).then(r=>{
                if(r.code == 200){
                    this.subEntity = []
                    for(let i of r.data){
                        var obj = {}
                        obj.label = i.name
                        obj.value = i.id
                        this.subEntity.push(obj)
                    }
                }else{
                    this.$message.error(r.message)
                }
            })
        },
        // 获取列表
        getList(){
            this.tableLoading = true
            let params = {
                current:this.page.pageNum,
                keyword:this.searchInput,
                size:this.page.pageSize,
                status:this.availableValue,
                entityId:this.$route.query.entityId
            }
            accessApi.getAccessList(params).then(r=>{
                this.tableLoading = false;
                if(r.code == 200){
                    this.tableData = r.data.records
                    this.page.total = r.data.total
                }else{
                    this.$message.error(r.message)
                }
            })
        },
        // 页数改变
        pageCurrentChange(num) {
            if(num !== this.page.pageNum) {
                this.page.pageNum = num;
                this.getList()
            }
        },
        // 页数据量改变
        pageSizeChange(size) {
            if(size !== this.page.pageSize) {
                this.page.pageSize = size;
                this.getList()
            }
        },
        // 编辑新增提交
        submit(formName){
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    if(this.addTitle == '新增门禁设备'){
                        this.addFun()
                    }else{
                        this.editFun()
                    }
                }else{
                    this.$message.warning('请完整填写表单再提交')
                }
            })
        },
        // 新增方法
        addFun(){
            this.butLoading =true
            let params = this.accessAdd
            params.entityId = this.$route.query.entityId
            params.subEntityId = params.subEntityId.toString()
            accessApi.addAccess(params).then(r=>{
                this.butLoading = false
                if(r.code == 200){
                    this.$message.success('新增成功')
                    this.addDialogVisible = false
                    this.getList()
                }
            })
        },
        // 编辑方法
        editFun(){
            this.butLoading =true
            let params = {
                deviceId: this.accessId,
                pointName: this.accessAdd.pointName,
                entityId: this.$route.query.entityId,
	            subEntityId: this.accessAdd.subEntityId
            }
            accessApi.editAccess(params).then(r=>{
                this.butLoading =false
                if(r.code == 200){
                    this.$message.success('编辑成功')
                    this.addDialogVisible = false
                    this.getList()
                }else{
                    this.$message.error(r.message)
                }
            })
        },
        // 搜索
        search(){
            this.page.pageNum = 1
            this.getList()
        },
        // 下拉筛选
        stateChange(){
            this.page.pageNum = 1
            this.getList()
        },
        // 新增
        add(formName) {
          this.addTitle = '新增门禁设备'
          this.accessAdd = {
                pointName:'',
                subEntityId:[],
                deviceType:'',
                deviceSerial:'',
                validateCode:'',
            },
          this.addDialogVisible = true
          this.$nextTick(()=>{
            this.$refs[formName].resetFields();
          })  
        },
        // 关闭弹窗
        cancle(){
          this.addDialogVisible = false
          this.accessAdd = {}
        },
        // 编辑
        edit(row){
          this.$set(this.accessAdd,'deviceType',row.deviceType)
          this.$set(this.accessAdd,'pointName',row.pointName)
          this.$set(this.accessAdd,'subEntityId',row.subEntityId)
          this.$set(this.accessAdd,'deviceSerial',row.deviceSerial)
          this.addTitle = '编辑门禁设备'
          this.accessId = row.deviceId
          this.addDialogVisible = true
        },
        // 启用禁用
        useChange(row){
            this.$confirm('是否确认' + (row.status === 1?'禁用':'启用') + '该点位?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.changeStatusFun(row.deviceId,row.status)
            }).catch(e => {});
        },
        // 启用禁用接口
        changeStatusFun(id,status){
            let params = {
                deviceId:id,
            }
            if(status == 1){
                accessApi.changeStatusDisable(params).then(r=>{
                    
                    if(r.code == 200){
                        this.$message.success('操作成功')
                        this.getList()
                    }else{
                        this.$message.error(r.message)
                    }
                })
            }else{
                accessApi.changeStatusEnable(params).then(r=>{
                    if(r.code == 200){
                        this.$message.success('操作成功')
                        this.getList()
                    }else{
                        this.$message.error(r.message)
                    }
                })
            }
        },
        // 删除
        del(row){
            this.$confirm('是否确认删除该门禁设备?','提示',{
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(()=>{
                this.deleteFun(row.deviceId)
            }).catch(e => {});
        },
        // 删除接口
        deleteFun(id){
            let params = {
                deviceId:id
            }
            accessApi.deleteAccess(params).then(r=>{
                if(r.code == 200){
                    this.$message.success('操作成功')
                    this.getList()
                }else{
                    this.$message.error(r.message)
                }
            })
        }
    }
}

</script>

<style lang='scss' scoped>
    .access-control-list {
        width: 100%;
        height: calc(100% - 40px);
        text-align: left;
        .click-link {
          cursor: pointer;
          position: absolute;
          bottom: 0;
        }
    }
    .footer {
        margin-top: 20px;
        text-align: right;
    }
</style>